import type { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { DatadogService } from "./datadog.service";

export const DatadogModule: Module = {
  name: "DatadogModule",
  modules: [LoggerModule],
  providers: [DatadogService],
};
